import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoujjaincab() {



  const cardData = {




keyword: "Pune to Ujjain Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Ujjain Cab Service for devotees, families, couples, senior citizens, business travelers, and groups planning a convenient long-distance journey. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for one-way travel, round trips, religious tours, family visits, and customized pilgrimage itineraries. With experienced drivers, clean and well-maintained vehicles, comfortable seating, practical luggage space, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes travel from Pune to Ujjain convenient and comfortable. Travelers can also combine Ujjain with important temples, heritage sites, and nearby pilgrimage destinations according to their preferred schedule.",

topPlaces: [
  {
    title: "Mahakaleshwar Temple",
    description: "Mahakaleshwar Temple is one of the most revered Shiva temples in India and is the main pilgrimage attraction in Ujjain. The temple is traditionally counted among the twelve Jyotirlingas and attracts devotees throughout the year. Travelers booking a Pune to Ujjain cab can plan a comfortable private journey with flexible timings for Darshan and convenient transportation to other religious places around the city."
  },
  {
    title: "Kal Bhairav Temple",
    description: "Kal Bhairav Temple is an important religious site in Ujjain dedicated to Lord Kal Bhairav and is known for its distinctive spiritual traditions. It is frequently included in pilgrimage itineraries along with Mahakaleshwar Temple and other Ujjain attractions. A private chauffeur-driven cab allows families and devotees to travel conveniently between the city's important temples according to their preferred schedule."
  },
  {
    title: "Harsiddhi Temple",
    description: "Harsiddhi Temple is a prominent Shakti temple in Ujjain and is known for its spiritual importance, traditional architecture, and distinctive lamp pillars. Devotees visiting Ujjain often include this temple in their pilgrimage route. Garud Cab Service provides comfortable cab transportation for passengers traveling from Pune who want to cover multiple religious attractions during their Ujjain visit."
  },
  {
    title: "Ram Ghat",
    description: "Ram Ghat is one of the most significant ghats along the Shipra River and is an important part of Ujjain's religious landscape. Pilgrims gather here for sacred rituals and to experience the peaceful atmosphere along the riverfront. Customers can include Ram Ghat in their Pune to Ujjain cab itinerary and travel comfortably between the ghat, temples, hotels, and other city attractions."
  },
  {
    title: "Sandipani Ashram",
    description: "Sandipani Ashram is a revered spiritual location associated with the traditional story of Lord Krishna's education under Guru Sandipani. The site attracts devotees and visitors interested in the religious heritage of Ujjain. A private cab provides convenient transportation for families and pilgrims who want to include the ashram along with other important spiritual destinations."
  },
  {
    title: "Mangalnath Temple",
    description: "Mangalnath Temple is an important Shiva temple in Ujjain situated in a peaceful location overlooking the Shipra River region. It has strong traditional associations with religious and astrological beliefs and is visited by devotees throughout the year. Garud Cab Service can arrange a comfortable private cab for travelers who want to include Mangalnath Temple in their customized pilgrimage itinerary."
  },
  {
    title: "Gadkalika Temple",
    description: "Gadkalika Temple is a respected religious site in Ujjain dedicated to Goddess Kalika and holds an important place in the city's spiritual traditions. The temple attracts devotees seeking blessings and is often included in local temple tours. Travelers arriving from Pune can use a private cab to visit Gadkalika along with other temples without relying on fixed public transportation."
  },
  {
    title: "Vedh Shala",
    description: "Vedh Shala, also known as the Ujjain Observatory, is a historic astronomical site featuring traditional instruments used for observing celestial movements and calculating astronomical positions. It offers a different experience from Ujjain's many temples and is interesting for history and science enthusiasts. Customers can include the observatory in their sightseeing plan while traveling comfortably by private cab."
  },
  {
    title: "Omkareshwar",
    description: "Omkareshwar is a major Shiva pilgrimage destination in Madhya Pradesh and is home to one of the twelve Jyotirlingas. Devotees traveling from Pune to Ujjain can extend their journey to include Omkareshwar as part of a longer religious tour. Garud Cab Service can arrange a multi-destination cab itinerary with flexible travel plans for families, couples, and groups."
  },
  {
    title: "Indore",
    description: "Indore is a major city near Ujjain known for its business centers, food culture, markets, historical attractions, and convenient transportation connections. Travelers can combine Indore with a Pune to Ujjain pilgrimage for additional sightseeing or personal travel requirements. A private cab provides flexibility to visit both cities while maintaining a comfortable and customized travel schedule."
  }
],



"services": [
{
"name": "Pune to Ujjain Cab",
"description": "Book Pune to Ujjain Cab for a comfortable and convenient long-distance journey with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cab options for Mahakal darshan, family trips, religious travel, sightseeing, one-way transfers, and round-trip journeys."
},
{
"name": "Pune to Ujjain Cab Service",
"description": "Choose Pune to Ujjain Cab Service for reliable private outstation transportation with experienced chauffeurs, comfortable AC interiors, and convenient pickup arrangements. The service is suitable for Mahakaleshwar Jyotirlinga darshan, family pilgrimages, tourists, senior passengers, personal visits, and planned one-way or round-trip travel."
},
{
"name": "Pune to Ujjain Taxi Service",
"description": "Book Pune to Ujjain Taxi Service for a smooth and private journey with professional drivers and comfortable air-conditioned vehicles. Select a Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to your group size, luggage requirements, travel duration, and preferred comfort level."
},
{
"name": "Pune to Ujjain Cab Booking",
"description": "Make Pune to Ujjain Cab Booking for a scheduled chauffeur-driven journey with convenient pickup and direct destination drop. Choose your preferred vehicle and travel timing for Mahakal darshan, family travel, religious tours, sightseeing, personal visits, and long-distance outstation transportation."
},
{
"name": "Best Pune to Ujjain Cab",
"description": "Choose Best Pune to Ujjain Cab for comfortable and dependable long-distance travel with experienced chauffeurs, clean AC vehicles, convenient pickup, and flexible journey options. Vehicle choices include Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV for families, pilgrims, tourists, and groups."
},
{
"name": "One Way Pune to Ujjain Cab",
"description": "Book One Way Pune to Ujjain Cab for a direct point-to-point journey without arranging return transportation. Enjoy private AC travel, professional chauffeur service, flexible pickup from your preferred Pune location, and suitable vehicle options for individuals, couples, families, senior passengers, and groups."
},
{
"name": "Round Trip Pune to Ujjain Taxi",
"description": "Reserve Round Trip Pune to Ujjain Taxi for convenient return transportation according to your pilgrimage or sightseeing schedule. Enjoy private AC travel, experienced chauffeur service, spacious luggage capacity, and flexible travel arrangements with Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options."
},
{
"name": "Cheap Pune to Ujjain Cab",
"description": "Book Cheap Pune to Ujjain Cab for economical private transportation with comfortable AC vehicles and professional chauffeur service. Select an affordable Sedan or Swift Dzire, or choose a spacious Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to your passenger and luggage requirements."
},
{
"name": "24x7 Pune to Ujjain Cab Service",
"description": "Choose 24x7 Pune to Ujjain Cab Service for flexible travel arrangements and scheduled chauffeur-driven transportation. Comfortable AC vehicles are available for pilgrims, families, tourists, business travelers, and groups requiring private long-distance transportation with convenient pickup and destination drop."
},
{
"name": "Outstation Cab Pune to Ujjain",
"description": "Book Outstation Cab Pune to Ujjain for a comfortable intercity journey with experienced chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options for Mahakal darshan, family trips, religious tours, sightseeing, business travel, and personal visits."
},
{
"name": "Pune to Indore Taxi",
"description": "Reserve Pune to Indore Taxi for convenient private transportation between Pune and Indore with professional chauffeurs and comfortable AC vehicles. Select a Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to your group size, luggage requirements, and one-way or round-trip travel plan."
},
{
"name": "Pune to Bhopal Taxi",
"description": "Book Pune to Bhopal Taxi for reliable long-distance travel with experienced drivers, comfortable AC interiors, and convenient pickup arrangements. Vehicle options are available for families, corporate travelers, tourists, groups, and passengers planning one-way, round-trip, sightseeing, or personal journeys."
},
{
"name": "Pune to Gwalior Cab Booking",
"description": "Make Pune to Gwalior Cab Booking for comfortable chauffeur-driven transportation on a long-distance route. Choose from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV vehicles according to passenger capacity and luggage requirements for family trips, business travel, sightseeing, and personal visits."
},
{
"name": "Pune to Jabalpur Taxi",
"description": "Choose Pune to Jabalpur Taxi for a private and comfortable intercity journey with professional chauffeurs and clean air-conditioned vehicles. The service is suitable for families, tourists, corporate passengers, groups, and individuals planning one-way transfers, return journeys, sightseeing, or extended travel."
},
{
"name": "Pune to Ujjain Outstation Cab",
"description": "Book Pune to Ujjain Outstation Cab for dependable long-distance transportation with professional chauffeur service and comfortable AC vehicles. Travel conveniently for Mahakaleshwar darshan, family pilgrimages, religious tours, sightseeing, and personal visits with Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options."
},
{
"name": "Pune to Indore Innova Crysta",
"description": "Hire Pune to Indore Innova Crysta for premium and spacious chauffeur-driven travel between Pune and Indore. Enjoy comfortable AC interiors, generous seating, luggage space, and a relaxed journey suitable for families, business travelers, groups, sightseeing, one-way transfers, and round trips."
},
{
"name": "Pune to Bhopal Tempo Traveller",
"description": "Book Pune to Bhopal Tempo Traveller for comfortable group transportation on a long-distance journey. The spacious vehicle is suitable for families, friends, corporate groups, religious travelers, and tour groups requiring ample seating, luggage capacity, AC comfort, and professional chauffeur-driven travel."
},
{
"name": "Pune to Ujjain Urbania",
"description": "Choose Pune to Ujjain Urbania for premium group transportation with spacious seating, comfortable interiors, air conditioning, and professional chauffeur service. Force Urbania is suitable for families, friends, corporate groups, pilgrimage tours, and travelers planning a comfortable journey to Ujjain."
},
{
"name": "Luxury Cab Pune Madhya Pradesh",
"description": "Book Luxury Cab Pune Madhya Pradesh for premium chauffeur-driven transportation to Ujjain, Indore, Bhopal, Gwalior, Jabalpur, and other destinations. Choose a premium Innova Crysta, Kia Carens, SUV, or other comfortable vehicle for business travel, family tours, pilgrimage journeys, and long-distance trips."
},
{
"name": "Best Pune to Indore Cab Service",
"description": "Choose Best Pune to Indore Cab Service for dependable private transportation with experienced chauffeurs, clean AC vehicles, comfortable seating, and convenient pickup arrangements. Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options are suitable for families, tourists, business travelers, and groups."
},
{
"name": "Cheap Pune to Bhopal Taxi",
"description": "Book Cheap Pune to Bhopal Taxi for economical long-distance transportation with comfortable AC vehicles and professional chauffeur service. Select a Sedan for budget-friendly travel or choose Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options for additional passenger and luggage capacity."
},
{
"name": "Book Pune to Ujjain Cab Online",
"description": "Book Pune to Ujjain Cab Online for convenient scheduled transportation with flexible pickup and direct destination drop. Select your preferred vehicle according to passenger count, luggage requirements, and journey type for Mahakal darshan, family travel, religious tours, sightseeing, and round-trip journeys."
},
{
"name": "One Way Taxi Pune to Gwalior",
"description": "Reserve One Way Taxi Pune to Gwalior for a direct intercity journey without arranging return transportation. Enjoy comfortable AC travel, professional chauffeur service, convenient pickup, and suitable vehicle options for individuals, couples, families, corporate travelers, tourists, and groups."
},
{
"name": "Tempo Traveller Pune to Jabalpur",
"description": "Book Tempo Traveller Pune to Jabalpur for spacious and comfortable group transportation on a long-distance journey. The vehicle is suitable for family tours, pilgrimage groups, friends, corporate teams, and larger parties requiring comfortable seating, luggage space, AC travel, and professional chauffeur service."
},
{
"name": "Urbania on Rent Pune to Indore",
"description": "Hire Urbania on Rent Pune to Indore for premium group transportation with a professional chauffeur, spacious seating, comfortable interiors, and air conditioning. The vehicle is suitable for family trips, corporate travel, group tours, sightseeing, religious journeys, and long-distance travel between Pune and Indore."
},
{
"name": "Family Cab Pune to Ujjain",
"description": "Book Family Cab Pune to Ujjain for a comfortable pilgrimage and family journey with spacious seating, AC interiors, luggage capacity, and professional chauffeur service. Choose an Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to your family size and travel requirements."
},
{
"name": "Luxury Taxi Pune Madhya Pradesh",
"description": "Choose Luxury Taxi Pune Madhya Pradesh for premium private transportation to destinations such as Ujjain, Indore, Bhopal, Gwalior, and Jabalpur. Enjoy comfortable premium vehicles, professional chauffeurs, spacious interiors, and flexible one-way or round-trip arrangements for family, corporate, pilgrimage, and leisure travel."
},
{
"name": "Affordable Pune to Indore Cab Service",
"description": "Book Affordable Pune to Indore Cab Service for economical and comfortable outstation transportation with professional chauffeurs and clean AC vehicles. Choose Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options based on passenger count, luggage requirements, journey type, and comfort preferences."
},
{
"name": "Pune to Ujjain Innova Crysta on Rent",
"description": "Hire Pune to Ujjain Innova Crysta on Rent for premium chauffeur-driven travel with spacious seating, comfortable AC interiors, generous luggage capacity, and a smooth long-distance journey. It is suitable for families, senior passengers, groups, pilgrims, and travelers planning Mahakal darshan or extended Ujjain trips."
},
{
"name": "Luxury Tempo Traveller Pune Bhopal",
"description": "Book Luxury Tempo Traveller Pune Bhopal for comfortable premium group transportation with spacious seating, AC interiors, ample luggage capacity, and professional chauffeur service. It is suitable for family tours, corporate groups, pilgrimage journeys, sightseeing trips, and long-distance travel with multiple passengers."
},
{
"name": "Force Urbania Pune to Indore",
"description": "Choose Force Urbania Pune to Indore for spacious and premium group travel with comfortable seating, air conditioning, luggage space, and professional chauffeur service. The vehicle is ideal for families, friends, corporate teams, tourists, and groups planning a comfortable long-distance journey."
},
{
"name": "Pune to Gwalior Family Trip Cab",
"description": "Book Pune to Gwalior Family Trip Cab for convenient family transportation with comfortable AC interiors, spacious seating, luggage capacity, and an experienced chauffeur. Select Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to your family size and travel requirements."
},
{
"name": "Corporate Taxi Pune Jabalpur",
"description": "Choose Corporate Taxi Pune Jabalpur for professional chauffeur-driven transportation suitable for business meetings, employee travel, corporate visits, client transportation, and long-distance assignments. Comfortable AC Sedan, MUV, Innova Crysta, Kia Carens, and SUV options are available according to corporate travel requirements."
},
{
"name": "Pune to Ujjain Mahakal Darshan Cab",
"description": "Book Pune to Ujjain Mahakal Darshan Cab for a convenient private pilgrimage journey to Mahakaleshwar Jyotirlinga. Enjoy comfortable AC travel, professional chauffeur service, flexible pickup, spacious luggage capacity, and suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options for families and devotees."
},
{
"name": "Round Trip Pune Indore Cab",
"description": "Reserve Round Trip Pune Indore Cab for convenient return transportation according to your business, family, sightseeing, or personal travel schedule. Enjoy private AC transportation, professional chauffeur service, flexible pickup, and comfortable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options."
},
{
"name": "Pune to Omkareshwar Jyotirlinga Cab",
"description": "Book Pune to Omkareshwar Jyotirlinga Cab for a comfortable private pilgrimage journey with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options for devotees, families, senior passengers, religious groups, and round-trip sightseeing plans."
},
{
"name": "Pune to Mahakaleshwar Jyotirlinga Cab",
"description": "Reserve Pune to Mahakaleshwar Jyotirlinga Cab for convenient private transportation to Ujjain for Mahakal darshan. Enjoy experienced chauffeur service, comfortable AC interiors, spacious luggage capacity, and flexible one-way or round-trip travel options suitable for families, devotees, senior passengers, and pilgrimage groups."
}
],
"tableData": [
["Pune to Ujjain Cab", "Pune to Ujjain Cab Service"],
["Pune to Ujjain Taxi Service", "Pune to Ujjain Cab Booking"],
["Best Pune to Ujjain Cab", "One Way Pune to Ujjain Cab"],
["Round Trip Pune to Ujjain Taxi", "Cheap Pune to Ujjain Cab"],
["24x7 Pune to Ujjain Cab Service", "Outstation Cab Pune to Ujjain"],
["Pune to Indore Taxi", "Pune to Bhopal Taxi"],
["Pune to Gwalior Cab Booking", "Pune to Jabalpur Taxi"],
["Pune to Ujjain Outstation Cab", "Pune to Indore Innova Crysta"],
["Pune to Bhopal Tempo Traveller", "Pune to Ujjain Urbania"],
["Luxury Cab Pune Madhya Pradesh", "Best Pune to Indore Cab Service"],
["Cheap Pune to Bhopal Taxi", "Book Pune to Ujjain Cab Online"],
["One Way Taxi Pune to Gwalior", "Tempo Traveller Pune to Jabalpur"],
["Urbania on Rent Pune to Indore", "Family Cab Pune to Ujjain"],
["Luxury Taxi Pune Madhya Pradesh", "Affordable Pune to Indore Cab Service"],
["Pune to Ujjain Innova Crysta on Rent", "Luxury Tempo Traveller Pune Bhopal"],
["Force Urbania Pune to Indore", "Pune to Gwalior Family Trip Cab"],
["Corporate Taxi Pune Jabalpur", "Pune to Ujjain Mahakal Darshan Cab"],
["Round Trip Pune Indore Cab", "Pune to Omkareshwar Jyotirlinga Cab"],
["Pune to Mahakaleshwar Jyotirlinga Cab", ""]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Ujjain Cab for a Comfortable Religious Journey",
    WhyChoosedescription: "Garud Cab Service provides private Pune to Ujjain cab services for devotees, families, senior citizens, couples, and groups travelling to Ujjain for Mahakaleshwar darshan, religious visits, and sightseeing."
  },
  {
    WhyChooseheading: "Dedicated Cab for Long-Distance Travel",
    WhyChoosedescription: "Enjoy a private road journey from Pune to Ujjain without sharing the vehicle with other passengers, giving you greater control over departure timings, breaks, luggage, and travel comfort."
  },
  {
    WhyChooseheading: "Convenient for Mahakaleshwar Darshan",
    WhyChoosedescription: "Plan your journey around your preferred temple visit and sightseeing schedule, making a private cab a useful option for devotees travelling to Ujjain with family members."
  },
  {
    WhyChooseheading: "Comfortable Choice for Families",
    WhyChoosedescription: "Families can select a suitable vehicle according to passenger count and luggage requirements, allowing everyone to travel together during the long-distance journey."
  },
  {
    WhyChooseheading: "One-Way & Round-Trip Options",
    WhyChoosedescription: "Book a one-way cab if you need a direct drop in Ujjain, or choose a round-trip arrangement when you plan to return to Pune after completing your pilgrimage or visit."
  },
  {
    WhyChooseheading: "Explore Ujjain's Religious Attractions",
    WhyChoosedescription: "Along with Mahakaleshwar Temple, your itinerary can include destinations such as Kal Bhairav Temple, Harsiddhi Temple, Ram Ghat, Mahakal Lok, and other suitable places according to your available time."
  },
  {
    WhyChooseheading: "Pickup from Your Preferred Pune Location",
    WhyChoosedescription: "Start the journey from your home, hotel, office, residential society, railway station area, or another convenient pickup location in Pune."
  },
  {
    WhyChooseheading: "Plan Your Ujjain Trip with Garud",
    WhyChoosedescription: "Share your Pune pickup point, Ujjain destination, travel date, passenger count, vehicle preference, darshan plans, and one-way or return requirement with Garud Cab Service."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Ujjain Cab Service?",
    answer: "Yes, Garud Cab Service provides private Pune to Ujjain cab services for religious trips, Mahakaleshwar darshan, family travel, senior citizens, couples, and groups."
  },
  {
    question: "Can I book a one-way cab from Pune to Ujjain?",
    answer: "Yes, one-way cab service is available for passengers who need direct transportation from Pune to their preferred destination in Ujjain."
  },
  {
    question: "Can I book a round-trip cab to Ujjain?",
    answer: "Yes, round-trip arrangements can be planned according to your darshan schedule, sightseeing plans, stay duration, and preferred return date."
  },
  {
    question: "Can I visit Mahakaleshwar Temple with this cab service?",
    answer: "Yes, the cab can be used for transportation to Mahakaleshwar Temple and other Ujjain destinations included in your planned itinerary."
  },
  {
    question: "Which places can I visit in Ujjain?",
    answer: "Your itinerary can include Mahakaleshwar Temple, Mahakal Lok, Kal Bhairav Temple, Harsiddhi Temple, Ram Ghat, and other suitable religious or sightseeing attractions."
  },
  {
    question: "Is Pune to Ujjain cab suitable for senior citizens?",
    answer: "Yes, private cab travel can be convenient for senior devotees because the journey can be planned with suitable breaks and flexible sightseeing timings."
  },
  {
    question: "Can families book a private cab to Ujjain?",
    answer: "Yes, families can arrange a dedicated vehicle based on their passenger count, luggage, and comfort requirements."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can I include other religious places in the itinerary?",
    answer: "Yes, additional religious and sightseeing destinations can be discussed while planning the journey based on your available time and selected route."
  },
  {
    question: "How can I book a Pune to Ujjain Cab?",
    answer: "Share your Pune pickup location, Ujjain destination, travel date, passenger details, preferred vehicle, sightseeing requirements, and trip type with Garud Cab Service to arrange your cab."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rajendra Patil",
    feedback: "Our family travelled from Pune to Ujjain for Mahakaleshwar darshan. The private cab was convenient because we could plan our journey and sightseeing according to our family schedule.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Deshmukh",
    feedback: "We booked a round-trip cab for our Ujjain pilgrimage. Travelling privately was comfortable for our group and made it easier to manage the temple visits and luggage.",
    rating: 5
  }
];



  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ujjain Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-ujjain-cab.webp",
  "description": "Book Pune to Ujjain Cab with Garud Cab for safe, comfortable, and reliable long-distance and pilgrimage travel. Get one way and round trip cab services from Pune to Ujjain with Sedan, Ertiga, SUV, Innova, and Innova Crysta options for Mahakaleshwar Darshan, family journeys, religious tours, and intercity travel with convenient pickup and drop facilities.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-ujjain-cab"
  }
};



  return (
    <div>

<Helmet>
  <title>Pune to Ujjain Cab | One Way & Round Trip Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Ujjain Cab with Garud Cab for comfortable and reliable travel. Get one way and round trip taxi services for Ujjain and Mahakaleshwar Darshan with Sedan, Ertiga, SUV, Innova, and Innova Crysta cab options."
  />

  <meta
    name="keywords"
    content="Pune to Ujjain Cab, Pune to Ujjain Cab Service, Pune to Ujjain Taxi Service, Pune to Ujjain Cab Booking, Best Pune to Ujjain Cab, One Way Pune to Ujjain Cab, Round Trip Pune to Ujjain Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoujjaincab;